<!-- button/any trigger element goes here -->
<ng-content select="[viewTrigger]"></ng-content>

<!-- hidden -->
<select
    class="select-ui-dropdown"
    [ngModel]="selected"
></select>

<small *ngIf="!trigger">
    &lt;cmps-ui-dropdown&gt;:
    {{
        i18n._7412_PLEASE_PROVIDE_A_CLICKABLE_ELEMENT_WITH_A__VIEWTRIGGER__ATTRIBUTE
            | translate
    }}.
</small>

<div
    #optionsContainer
    documentBlurTrigger
    [triggerFlag]="focused"
    (documentBlurred)="toggle($event)"
    class="view-options-container"
    [ngClass]="dropdownPosition"
    *ngIf="focused === true"
>
    <div class="overflow-container">
        <ng-content select="[optionsHeader]"></ng-content>

        <div class="overflow-scrollbar">
            <ng-container
                *ngTemplateOutlet="
                    loadingTemplate;
                    context: { loading: loading }
                "
            >
            </ng-container>

            <ng-container
                *ngIf="searchResults && searchResults.length; else noResults"
            >
                <span
                    >{{ i18n._97_SEARCH_RESULTS | translate }} ({{
                        searchResults.length
                    }}):</span
                >
                <ul class="ui-dropdown-search-results">
                    <li *ngFor="let res of searchResults; let i = index">
                        <div
                            class="ui-dropdown-search-result-item view-option"
                            tabindex="0"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    searchResultTemplate;
                                    context: { result: res }
                                "
                            >
                            </ng-container>
                        </div>
                    </li>
                </ul>
            </ng-container>
            <ng-template #noResults>
                <div
                    *ngIf="searchQuery && searchQuery.length >= 3 && !loading"
                    class="ui-dropdown-search-results"
                >
                    {{ i18n._7413_NO_RESULTS_FOUND | translate }}.
                </div>
            </ng-template>

            <ul class="favourites-list">
                <li
                    *ngFor="let option of options"
                    class="view-option"
                    [ngClass]="{ active: selected.value == option.value }"
                    (click)="select(option)"
                >
                    <ng-container
                        *ngTemplateOutlet="
                            optionTemplate;
                            context: { option: option }
                        "
                    >
                    </ng-container>
                </li>
            </ul>
        </div>

        <ng-template #noOptions>
            <ng-content select="[nodata]"></ng-content>
        </ng-template>
    </div>
</div>
